import { useEffect, type ReactNode } from "react";
import { getCalApi } from "@calcom/embed-react";
import { CAL_LINK, CAL_NAMESPACE } from "../lib/cal";

type Props = {
  children?: ReactNode;
  variant?: "solid" | "ghost";
  className?: string;
};

// Book-a-demo CTA. Opens the Cal.com booking modal for the `dash-demo` event type.
// Safe to render multiple times on the page — Cal.com initialises the namespace once
// and all buttons with the matching data-cal-namespace share the modal.
export default function BookDemoButton({
  children = "Book a demo",
  variant = "solid",
  className = "",
}: Props) {
  useEffect(() => {
    (async () => {
      const cal = await getCalApi({ namespace: CAL_NAMESPACE });
      cal("ui", {
        hideEventTypeDetails: false,
        layout: "month_view",
        cssVarsPerTheme: {
          light: { "cal-brand": "#11171B" },
          dark: { "cal-brand": "#E9ECEC" },
        },
      });
    })().catch((err) => {
      // eslint-disable-next-line no-console
      console.error("[Dash] Cal.com embed failed to initialise", err);
    });
  }, []);

  const cls =
    variant === "ghost"
      ? `dash-btn dash-btn--ghost ${className}`.trim()
      : `dash-btn ${className}`.trim();

  return (
    <button
      type="button"
      className={cls}
      data-cal-namespace={CAL_NAMESPACE}
      data-cal-link={CAL_LINK}
      data-cal-config='{"layout":"month_view"}'
    >
      {children}
    </button>
  );
}
